var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support-wrap"},[_c('h5',{staticClass:"support-label",class:{'blk': _vm.isLightMode }},[_vm._v("Having trouble? Delete account with a GuRoo")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"support-label"},[_c('a',{staticClass:"support-link",attrs:{"target":"_blank","href":"tel:+18884575439"}},[_vm._v("+1 888-457-5439")])])
}]

export { render, staticRenderFns }